import type { ActionProperties, DeploymentActionResource } from "@octopusdeploy/octopus-server-client";
import convertPropertyValueResourceToString from "~/components/convertPropertyValueResourceToString";
export function getProcessTemplateVersionMaskFromAction(action: DeploymentActionResource) {
    return getProcessTemplateVersionMaskFromActionProperties(action.Properties);
}
export function getProcessTemplateSlugFromAction(action: DeploymentActionResource) {
    return getProcessTemplateSlugFromActionProperties(action.Properties);
}
export function getProcessTemplateVersionMaskFromActionProperties(actionProperties: ActionProperties) {
    return convertPropertyValueResourceToString(actionProperties["Octopus.Action.ProcessTemplate.Reference.VersionMask"]);
}
export function getProcessTemplateSlugFromActionProperties(actionProperties: ActionProperties) {
    return convertPropertyValueResourceToString(actionProperties["Octopus.Action.ProcessTemplate.Reference.Slug"]);
}
